<script lang="ts">
	import type { Snippet } from 'svelte';
	import IconCheckboxChecked from 'virtual:icons/material-symbols/check-box';
	import IconCheckboxBlank from 'virtual:icons/material-symbols/check-box-outline-blank';

	interface Props {
		checked: boolean;
		disabled?: boolean;
		required?: boolean;
		checkPosition?: 'start' | 'end';
		children?: Snippet;
	}

	let {
		disabled,
		children,
		required,
		checkPosition = 'start',
		checked = $bindable()
	}: Props = $props();
</script>

<label class="checkbox" class:check-end={checkPosition === 'end'}>
	<input {disabled} {required} bind:checked tabindex="0" type="checkbox" />
	<div class="icon">
		{#if checked}
			<IconCheckboxChecked />
		{:else}
			<IconCheckboxBlank />
		{/if}
	</div>
	{@render children?.()}
</label>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.checkbox {
		@include lib.flex-row();
		@include lib.flex-align(flex-start, center);
		gap: 0.75rem;
		cursor: pointer;
		font-size: 0.875rem;
		padding: var(--checkbox-padding, 0);

		input[type='checkbox'] {
			position: absolute;
			opacity: 0;
			width: 0;
			height: 0;
		}

		.icon {
			font-size: 1rem;
			flex-shrink: 0;
			color: var(--checkbox-color, var(--text-primary));
		}

		&.check-end .icon {
			order: 1;
			margin-left: auto;
		}
	}
</style>
